import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./Contexts/AuthContext";
import Spinner from "react-bootstrap/Spinner";
import BottomNavBar from "./Navbar/BottomNavbar"; // Make sure to import the BottomNavBar
import { isSuperAdminSubdomain } from "../services/utils/utiltyFunctions";
import React from "react";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="grow">
          <div className="content" />
        </Spinner>
      </div>
    );
  }

  // BottomNavBar is for org-scoped users (checks log, audit log, etc.).
  // The super-admin shell has its own self-contained navigation in the
  // page header, so skip it here.
  const showBottomNav = !isSuperAdminSubdomain();

  return isAuthenticated ? (
    <>
      <Outlet />
      {showBottomNav && <BottomNavBar />}
    </>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
